<template>
  <div class="apply">

    <div class="apply-top">
      <van-nav-bar title="面试通过人员列表">
        <template #left>
          <van-icon name="arrow-left" size="24" @click="goBack"/>
        </template>
        <template #right>
          <van-icon name="replay" size="24" @click="reset"/>
        </template>
      </van-nav-bar>
      <van-dropdown-menu>
        <van-dropdown-item :title="cascaderText" ref="cascaderRef">
          <van-cascader
              v-model="cascaderValue"
              :options="cascaderOption"
              @finish="onCascaderConfirm"
              :show-header="false"
              :swipeable="false"
          />
        </van-dropdown-item>
        <van-dropdown-item v-model="qualification" :options="qualificationOption" @change="handleSearch" />
        <van-dropdown-item v-model="gender" :options="genderOption" @change="handleSearch" />
        <van-dropdown-item v-model="order" :options="orderOption" @change="handleSearch" />
      </van-dropdown-menu>
      <van-search clearable placeholder="请输入姓名" v-model="name"
                  @search="handleSearch"
                  @update:model-value="handleSearch" />
    </div>

    <div class="apply-body" ref="root">
      <van-skeleton :loading="loading" :row="3" :style="{ paddingTop: '16px' }">
        <van-empty v-if="dataList.length < 1" description="暂无面试通过人员" />
        <van-cell-group v-if="dataList.length > 0">
          <van-swipe-cell v-for="(data, index) in dataList" :key="data">
            <van-cell :key="data" @click="showResume(data)">
              <template #title>
                <span>{{ index+1 + '）' + data['name'] }}</span>
              </template>
              <template #value>
                <van-row justify="end">
                  <span v-if="data['acceptCompany']">{{ data['acceptCompany'] }}</span>
                </van-row>
              </template>
              <template #label>
                <van-row>
                  <van-space>
                    <van-tag plain type="primary" size="medium">{{ data['gender'] }}</van-tag>
                    <van-tag plain type="primary" size="medium" v-if="getQualification(data['educationExperiences'])">
                      {{ getQualification(data['educationExperiences']) }}
                    </van-tag>
                  </van-space>
                </van-row>
                <van-row style="padding-top: 4px">
                  <span>{{ parseTimeStr(data['accepttime']) }}</span>
                </van-row>
              </template>
            </van-cell>
          </van-swipe-cell>
        </van-cell-group>
      </van-skeleton>
    </div>

  </div>
</template>

<script>
import {getCompanyJobOption, getUserPassList} from "@/api";
import {showNotify} from "vant";
import {onActivated, ref} from "vue";
import {useEventListener, useScrollParent} from "@vant/use";
import {onBeforeRouteLeave} from "vue-router";
import {parseTime} from "@/api/common";

export default {
  name: "UserPassList",
  data() {
    return {
      loading: true,
      dataList: [],
      cascaderText: '全部职位',
      cascaderValue: '0',
      cascaderOption: [
        { text: '全部公司', value: '', children: [
            { text: '全部职位', value: '' }
          ] },
      ],
      companyId: '',
      jobId: '',
      name: '',
      qualification: '0',
      qualificationOption: [
        { text: '全部学历', value: '0' },
        { text: '本科', value: '本科' },
        { text: '硕士', value: '硕士' },
        { text: '博士', value: '博士' },
      ],
      gender: '0',
      genderOption: [
        { text: '全部性别', value: '0' },
        { text: '女', value: '女' },
        { text: '男', value: '男' },
      ],
      order: 'convert(name using gbk) asc',
      orderOption: [
        { text: '姓名正序', value: 'convert(name using gbk) asc' },
        { text: '创建时间倒序', value: 'createtime desc' },
      ],
    }
  },
  setup() {
    const root = ref();
    const scrollParent = useScrollParent(root);
    const savedScrollTop = ref(0);

    useEventListener(
        'scroll',
        () => {
          // console.log("scrollParent.scrollTop: "+scrollParent.value.scrollTop);
        },
        { target: scrollParent },
    );

    // 组件激活时恢复滚动位置
    onActivated(() => {
      if (scrollParent.value instanceof Element) {
        scrollParent.value.scrollTop = savedScrollTop.value;
      } else {
        window.scrollTo(0, savedScrollTop.value);
      }
      // console.log("blogcardlist被激活了");
      // console.log("savedScrollTop: " + savedScrollTop.value);
    });

    // 路由离开前保存滚动位置
    onBeforeRouteLeave((to, from, next) => {
      if (from.name === 'UserPassList' && to.name === 'ResumePassInfo') {
        savedScrollTop.value = scrollParent.value.scrollTop;
      } else {
        savedScrollTop.value = 0;
      }
      if (from.name === 'UserPassList' && to.name === 'HomePage') {
        history.go(0);// 刷新本页
      }
      // console.log("blogcardlist路由离开了");
      // console.log("savedScrollTop: " + savedScrollTop.value);
      next();
    });

    return { root };
  },
  mounted() {
    this.loading = true;
    this.reset();
  },
  unmounted() {
    this.$route.meta.keepAlive = true;
  },
  methods: {
    reset() {
      this.cascaderValue = '';
      this.cascaderText = '全部公司·全部职位';

      getCompanyJobOption().then((res) => {
        if (res.code === 200) {
          for (let data of res.data) {
            this.cascaderOption.push(data);
          }
        }
      });
      getUserPassList().then((res) => {
        if (res.code === 200) {
          this.dataList = res.data;
          this.loading = false;
        } else {
          showNotify({ type: 'danger', message: '服务器繁忙，请稍后再试。', position: 'bottom' });
        }
      });
    },
    goBack() {
      window.history.back();
    },
    onCascaderConfirm(option) {
      this.companyId = option['selectedOptions'][0]['value'];
      this.jobId = option['value'];
      let companyName = option['selectedOptions'][0]['text'];
      let jobName = option['selectedOptions'][1]['text'];
      if (this.companyId === '0' && this.jobId === '0') {
        this.cascaderText = '全部职位';
      } else {
        this.cascaderText = companyName + '·' + jobName;
      }
      this.$refs.cascaderRef.toggle();
      this.handleSearch();
    },
    handleSearch() {
      this.loading = true;
      let obj = 'order=' + this.order;
      let name = this.name;
      let qualification = this.qualification;
      let gender = this.gender;
      let companyId = this.companyId;
      let jobId = this.jobId;
      if (name != null && name !== '') {
        obj += ('&name=' + name);
      }
      if (qualification != null && qualification !== '0') {
        obj += ('&qualification=' + qualification);
      }
      if (gender != null && gender !== '0') {
        obj += ('&gender=' + gender);
      }
      if (companyId !== '0' && jobId !== '0') {
        if (companyId != null && companyId !== '') {
          obj += ('&companyId=' + companyId);
        }
        if (jobId != null && jobId !== '') {
          obj += ('&jobId=' + jobId);
        }
      }

      getUserPassList(obj).then((res) => {
        if (res.code === 200) {
          this.dataList = res.data;
          this.loading = false;
        } else {
          showNotify({ type: 'danger', message: '服务器繁忙，请稍后再试。', position: 'bottom' });
        }
      });
    },
    getQualification(educationExperiences) {
      let educationExperiencesJson = JSON.parse(educationExperiences);
      let educationJson = {};
      for (let i = 0; i < educationExperiencesJson.length; i++) {
        let education = educationExperiencesJson[i];
        let qualification = education['qualification'];
        educationJson[qualification] = education['school'];
      }
      if ('博士' in educationJson) {
        return '博士·' + educationJson['博士'];
      } else if ('硕士' in educationJson) {
        return '硕士·' + educationJson['硕士'];
      } else if ('本科' in educationJson) {
        return '本科·' + educationJson['本科'];
      } else {
        return null;
      }
    },
    showResume(data) {
      this.$router.push({
        name: 'ResumePassInfo',
        params: {
          resumeId: data['id']
        },
      });
      window.sessionStorage.setItem('resumeInfo', JSON.stringify(data));
    },
    parseTimeStr(time, pattern) {
      return parseTime(time, pattern);
    },
  }
}
</script>

<style scoped>
.apply {
  width:100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.apply-top {
  background-color: rgb(248,248,248);
  padding-bottom: 10px;
}

.apply-body {
  flex: 1;
  overflow-y: scroll;
  padding-bottom: 20px;
}

/deep/ .van-hairline--bottom:after {
  border: none;
}

/deep/ .van-dropdown-menu__bar {
  box-shadow: none;
}

/deep/ .van-dropdown-menu__bar--opened {
  box-shadow: 0 2px 12px rgba(100, 101, 102, .12);
}

/deep/ .van-cell__title {
  min-width: 70%;
}

/deep/ .van-cell__value {
  min-width: 30%;
}

/deep/ .van-hairline--top-bottom:after {
  border: none;
}

/deep/ .van-swipe-cell:after {
  position: absolute;
  box-sizing: border-box;
  content: " ";
  pointer-events: none;
  right: var(--van-padding-md);
  bottom: 0;
  left: var(--van-padding-md);
  border-bottom: 1px solid var(--van-cell-border-color);
  transform: scaleY(.5);
}
</style>